module.exports = __webpack_public_path__ + "img/architectureImg6.29c897c0.jpeg";